import axios from "axios";
import { getApiRoute } from "../utils/apiRoute";

const { REACT_APP_USE_TOKEN: USE_TOKEN } = process.env;

const apiVizionario = axios.create({
  baseURL: getApiRoute(),
  headers: {
    Accept: "application/json",
  },
});

apiVizionario.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(USE_TOKEN);
    if (token?.trim()) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);


apiVizionario.interceptors.response.use(
  (response) => response,
  (error) => {
    if (process.env.REACT_APP_ENV === "development") {
      console.error("API Error:", {
        data: error.response?.data,
        status: error.response?.status,
        headers: error.response?.headers,
        request: error.request,
        message: error.message,
        config: error.config,
      });
    }
    return Promise.reject(error);
  }
);

export default apiVizionario;
